import type {} from "@lit/react";
import { UploadDropZone as UploadDropZoneElement, } from "@vaadin/upload/vaadin-upload-drop-zone.js";
import * as React from "react";
import { createComponent, type WebComponentProps } from "../utils/createComponent.js";
export { UploadDropZoneElement, };
export type UploadDropZoneEventMap = Readonly<{}>;
const events = {} as UploadDropZoneEventMap;
export type UploadDropZoneProps = WebComponentProps<UploadDropZoneElement, UploadDropZoneEventMap>;
export const UploadDropZone = createComponent({
    elementClass: UploadDropZoneElement, events, react: React, tagName: "vaadin-upload-drop-zone"
});
